<div class="col-md-12 content-sec">

    <div class="d-flex">


        <img class="another-logo" [src]="selectedEvent['image_url'] ?? ''" style="object-fit: contain;" />
        <div class="sec-title">
            {{selectedEvent['event_name'] ?? ''}}
        </div>
        <div class="livesvg mx-1" style="margin-top: auto;margin-bottom: auto;">
            <i class="fa fa-circle text-danger-glow blink" style="font-size: 10px;"></i>
            <span class="mx-1" style="font-weight: 500;font-size: 11px;">Live</span>

        </div>

        <div class="refresh" style="margin-left: auto;margin-top: auto;margin-bottom: auto;">
            <div class="hideonsmall">
                <button (click)="selectEvent(selectedEvent)" class="form-control new-btn d-flex ">
                    @if(loading){
                    <svg class="loader" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px"
                        viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="#ffffff"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
                                to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                        </path>
                    </svg>
                    }
                    Refresh data
                </button>
            </div>
            <div class="showonsmall">

                <button (click)="selectEvent(selectedEvent)" class="form-control new-btn d-flex "
                    style="font-size: 10px;">
                    @if(loading){
                    <svg class="loader" version="1.1" id="loader-2" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px"
                        viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="#ffffff"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
                                to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                        </path>
                    </svg>
                    }
                    Refresh</button>
            </div>
        </div>
    </div>
    <div class=" mt-2" style="display: none;">
        <div class="d-flex">
            <div style="font-size: 11px;margin-top: 10px;">Real-time Event Metrics</div>
            <div class="refresh" style="margin-left: auto;">
                <button (click)="selectEvent(selectedEvent)" class="form-control new-btn d-flex"
                    style="font-size: 10px;">
                    @if(loading){
                    <svg class="loader" version="1.1" id="loader-2" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px"
                        viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <path fill="#ffffff"
                            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25"
                                to="360 25 25" dur="0.6s" repeatCount="indefinite" />
                        </path>
                    </svg>
                    }
                    Refresh data</button>
            </div>
        </div>
    </div>
    <div class="row mt-2">
        <div class="col-md-4 col-6" style="">
            <div class="cus-card">
                <span class="card-title">CP Base</span>
                <span class="card-value" id="cp_base">{{eventData.hasOwnProperty('get_cp_dashboard_details') &&
                    eventData['get_cp_dashboard_details'].length > 0 ?
                    eventData['get_cp_dashboard_details'][0]['xr_code_count'] : 0}}</span>
            </div>
        </div>
        <div class="col-md-4 col-6 seccard" style="">
            <div class="cus-card">
                <span class="card-title">Unique CP Attendance</span>
                <span class="card-value" id="unique_attendees">{{eventData.hasOwnProperty('get_cp_dashboard_details') &&
                    eventData['get_cp_dashboard_details'].length > 0 ?
                    eventData['get_cp_dashboard_details'][0]['unique_cp_attended_count'] : 0}}</span>
            </div>
        </div>
        <div class="col-md-4 col-6" style="">
            <div class="cus-card">
                <span class="card-title">Total PAX</span>
                <span class="card-value" id="total_pax">{{eventData.hasOwnProperty('get_cp_dashboard_details') &&
                    eventData['get_cp_dashboard_details'].length > 0 ?
                    eventData['get_cp_dashboard_details'][0]['actual_guest_attended'] : 0}}</span>
            </div>
        </div>

    </div>

    <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
            <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab" aria-controls="home"
                aria-selected="true">CP Bucket Details</a>
        </li>
        <li class="nav-item" role="presentation">
            <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile"
                aria-selected="false">SM Details</a>
        </li>
        <li class="nav-item" role="presentation">
            <a class="nav-link" id="zone-tab" data-bs-toggle="tab" href="#zone" role="tab" aria-controls="zone"
                aria-selected="false">Zone</a>
        </li>
        <li class="nav-item" role="presentation">
            <a class="nav-link" id="xr-hv-code-tab" data-bs-toggle="tab" href="#xr-hv-code" role="tab" aria-controls="xr-hv-code"
                aria-selected="false">XR/HV Code</a>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div class="tab-pane py-2 fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <div class="table-responsive">
                <table class="table mt-2" style="overflow-y: scroll;">
                    <thead class="">
                        <tr class="">
                            <th scope="col" class="card-tab textCol d-flex" style="border-top-left-radius: 8px;">
                                <div class="d-flex">
                                    <div>CP Bucket</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_bucket', 'cp') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_bucket', 'cp')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>

                            </th>
                            <th scope="col" class="card-tab textCol" style="">
                                <div class="d-flex">
                                    <div>CP Base</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_base', 'cp') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_base', 'cp')" class="arrow-svg mx-1" width="10"
                                        height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>CP Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_attended', 'cp') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_attended', 'cp')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>Pax Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('pax_attended', 'cp') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'pax_attended', 'cp')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol" style="border-top-right-radius: 8px;">
                                <div class="d-flex">
                                    <div>Attendance % </div>
                                    <svg [ngStyle]="{'transform': isTransformed('per_attendance', 'cp') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'per_attendance', 'cp')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="tbody" id="cp_tbody">
                        @if(!eventData['get_cp_activity_details']){
                        <tr>
                            <td colspan="5" style="text-align: center;">No data found</td>
                        </tr>
                        }
                        <tr *ngFor="let item of eventData['get_cp_activity_details']">
                            <td>{{item["cp_bucket"]}}</td>
                            <td>{{item["cp_base"]}}</td>
                            <td>{{item["cp_attended"]}}</td>
                            <td>{{item["pax_attended"]}}</td>
                            <td>
                                <div class='attend-card'>
                                    <i class='fa fa-circle mx-1' [ngClass]="getAttendanceColor(item.per_attendance)"
                                        style='font-size: 9px;margin-top:7px'></i>
                                    {{item["per_attendance"]}}%
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <div class="table-responsive">
                <table class="table mt-2" style="overflow-y: scroll;">
                    <thead class="">
                        <tr class="">
                            <th scope="col" class="card-tab textCol d-flex" style="border-top-left-radius: 8px;">
                                <div class="d-flex">
                                    <div>SM Name</div>
                                    <svg [ngStyle]="{'transform': isTransformed('sourcing_manager_name', 'sm') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'sourcing_manager_name', 'sm')"
                                        class="arrow-svg mx-1" width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>

                            </th>
                            <th scope="col" class="card-tab textCol" style="">
                                <div class="d-flex">
                                    <div>CP Base</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_base', 'sm') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_base', 'sm')" class="arrow-svg mx-1" width="10"
                                        height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>CP Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_attended', 'sm') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_attended', 'sm')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>Pax Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('pax_attended', 'sm') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'pax_attended', 'sm')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol" style="border-top-right-radius: 8px;">
                                <div class="d-flex">
                                    <div>Attendance % </div>
                                    <svg [ngStyle]="{'transform': isTransformed('per_attendance', 'sm') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'per_attendance', 'sm')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="tbody" id="sm_tbody">
                        @if(!eventData['get_sm_activity_details']){
                        <tr>
                            <td colspan="5" style="text-align: center;">No data found</td>
                        </tr>
                        }
                        <tr *ngFor="let item of eventData['get_sm_activity_details']">
                            <td>{{item["sourcing_manager_name"]}}</td>
                            <td>{{item["cp_base"]}}</td>
                            <td>{{item["cp_attended"]}}</td>
                            <td>{{item["pax_attended"]}}</td>
                            <td>
                                <div class='attend-card'>

                                    <i class='fa fa-circle mx-1' [ngClass]="getAttendanceColor(item.per_attendance)"
                                        style='font-size: 9px;margin-top:7px'></i>
                                    {{item["per_attendance"]}}%
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="tab-pane fade" id="zone" role="tabpanel" aria-labelledby="zone-tab">
            <div class="table-responsive">
                <table class="table mt-2" style="overflow-y: scroll;">
                    <thead class="">
                        <tr class="">
                            <th scope="col" class="card-tab textCol d-flex" style="border-top-left-radius: 8px;">
                                <div class="d-flex">
                                    <div>Zone Name</div>
                                    <svg [ngStyle]="{'transform': isTransformed('market_zone', 'zone') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'market_zone', 'zone')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>

                            </th>
                            <th scope="col" class="card-tab textCol" style="">
                                <div class="d-flex">
                                    <div>CP Base</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_base', 'zone') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_base', 'zone')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>CP Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('cp_attended', 'zone') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'cp_attended', 'zone')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>Pax Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('pax_attended', 'zone') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'pax_attended', 'zone')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol" style="border-top-right-radius: 8px;">
                                <div class="d-flex">
                                    <div>Attendance % </div>
                                    <svg [ngStyle]="{'transform': isTransformed('per_attendance', 'zone') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'per_attendance', 'zone')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="tbody" id="sm_tbody">
                        @if(!eventData['get_cp_zone_details']){
                        <tr>
                            <td colspan="5" style="text-align: center;">No data found</td>
                        </tr>
                        }
                        <tr *ngFor="let item of eventData['get_cp_zone_details']">
                            <td>{{item["market_zone"]}}</td>
                            <td>{{item["cp_base"]}}</td>
                            <td>{{item["cp_attended"]}}</td>
                            <td>{{item["pax_attended"]}}</td>
                            <td>
                                <div class='attend-card'>
                                    <i class='fa fa-circle mx-1' [ngClass]="getAttendanceColor(item.per_attendance)"
                                        style='font-size: 9px;margin-top:7px'></i>
                                    {{item["per_attendance"]}}%
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="tab-pane fade" id="xr-hv-code" role="tabpanel" aria-labelledby="xr-hv-code-tab">
            <div class="d-flex justify-content-end mt-2 mb-1">
                <div style="position: relative; width: 100%;">
                    <i class="fa fa-search" style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%); font-size: 11px; color: #141F2E9E;"></i>
                    <input
                        type="text"
                        [(ngModel)]="xrHvSearch"
                        placeholder="Search by XR/HV Code or SM Name or Type"
                        class="form-control"
                        style="font-size: 12px; border-radius: 8px; border: 1px solid #e0e0e0; padding: 6px 12px 6px 28px;" />
                </div>
            </div>
            <div class="table-responsive">
                <table class="table mt-2" style="overflow-y: scroll;">
                    <thead class="">
                        <tr class="">
                            <th scope="col" class="card-tab textCol d-flex" style="border-top-left-radius: 8px;">
                                <div class="d-flex">
                                    <div>XR/HV Code</div>
                                    <svg [ngStyle]="{'transform': isTransformed('XR_HV_Code', 'xr-hv-code') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'XR_HV_Code', 'xr-hv-code')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>

                            </th>
                            <th scope="col" class="card-tab textCol" style="">
                                <div class="d-flex">
                                    <div>Attended</div>
                                    <svg [ngStyle]="{'transform': isTransformed('Is_Attended', 'xr-hv-code') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'Is_Attended', 'xr-hv-code')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>Type</div>
                                    <svg [ngStyle]="{'transform': isTransformed('Type', 'xr-hv-code') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'Type', 'xr-hv-code')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                            <th scope="col" class="card-tab textCol">
                                <div class="d-flex">
                                    <div>Sourcing Manager Name</div>
                                    <svg [ngStyle]="{'transform': isTransformed('Sourcing_Manager_Name', 'xr-hv-code') ? 'rotate(180deg)' : 'rotate(0deg)'}"
                                        (click)="sortingData($event, 'Sourcing_Manager_Name', 'xr-hv-code')" class="arrow-svg mx-1"
                                        width="10" height="7" viewBox="0 0 10 7" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M2.71821 0.690613C1.50658 0.690613 0.900763 0.690613 0.620234 0.930207C0.376824 1.1381 0.24765 1.44995 0.272765 1.76907C0.30171 2.13685 0.730087 2.56523 1.58684 3.42198L3.7241 5.55924C4.12011 5.95526 4.31812 6.15327 4.54645 6.22746C4.7473 6.29271 4.96364 6.29271 5.16449 6.22746C5.39281 6.15327 5.59082 5.95526 5.98684 5.55924L8.1241 3.42199C8.98085 2.56523 9.40923 2.13685 9.43817 1.76907C9.46329 1.44995 9.33411 1.1381 9.0907 0.930207C8.81017 0.690613 8.20436 0.690613 6.99273 0.690613H2.71821Z"
                                            fill="#141F2E" fill-opacity="0.62" />
                                    </svg>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody class="tbody" id="sm_tbody">
                       <tr *ngIf="!filteredXrHvData.length">
                            <td colspan="5" style="text-align:center;">No data found</td>
                        </tr>

                        <tr *ngFor="let item of filteredXrHvData">
                            <td>{{ item.XR_HV_Code }}</td>
                            <td>
                                <div class='attend-card'>
                                    <i class='fa fa-circle mx-1' 
                                    [ngClass]="item.Is_Attended ? 'text-green-glow' : 'text-red-glow'"
                                    style='font-size: 9px; margin-top: 7px'></i>
                                    {{ item.Is_Attended ? 'Yes' : 'No' }}
                                </div>
                            </td>
                            <td>
                                {{ item.Type === 'pre-register' ? 'In Base' : item.Type === 'onspot' ? 'Onspot' : item.Type }}
                            </td>
                            <td>{{ item.Sourcing_Manager_Name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <footer class="footer">
        Powered by Xanadu Technology. For support, contact tech.support&#64;xanadu.in
    </footer>
</div>